import { toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-43bdc30c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "pre-order-price-box" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("path", {
  "fill-rule": "evenodd",
  fill: "#0668E1",
  d: "M31.758 28.435h-6.493l-8.826-10.936 8.826-10.936h6.493l-8.826 10.936 8.826 10.936zm-7.781 6.015H13.913L.232 17.499 13.913.547h10.064L10.296 17.499 23.977 34.45z"
}, null, -1))
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      style: _normalizeStyle([_ctx.reverse && { order: 3 }])
    }, _toDisplayString(Number(_ctx.toman).toLocaleString()) + " تومان ", 5),
    (_openBlock(), _createElementBlock("svg", {
      style: _normalizeStyle([_ctx.reverse && { order: 2 }]),
      xmlns: "http://www.w3.org/2000/svg",
      width: "32",
      height: "35"
    }, _hoisted_3, 4)),
    _createElementVNode("div", {
      style: _normalizeStyle([_ctx.reverse && { order: 1 }]),
      class: "font-english"
    }, _toDisplayString(Number(_ctx.tether).toLocaleString()) + " تتر ", 5)
  ]))
}